



























import { Component, Inject, Vue } from 'vue-property-decorator'
import { Branding } from '@/api/model/branding'
import { BrandingAPI } from '@/api/backend-client'
import { cloneDeep, isEqual } from 'lodash'

@Component
export default class CompanySettingsBranding extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    branding: Branding = null
    loading: boolean = false

    async created() {
        await this.reload()
    }

    async reload() {
        this.loading = true
        this.branding = cloneDeep<Branding>(this.$currentCompany.branding)
        this.loading = false
    }

    async save() {
        try {
            this.loading = true
            await BrandingAPI.update(this.branding.id, this.branding)
            await this.reloadCompany()
            await this.reload()

        } finally {
            this.loading = false
        }
    }

    get hasChanges(): boolean {
        return isEqual(this.$currentCompany.branding, this.branding) === false
    }
}
